module.exports = __webpack_public_path__ + "static/media/_BID5532.b613c1f5.png";